<template>
  <div style="position: absolute; z-index: 20; right: 10px; top: 84px">
    <div
      v-if="$store.state.popupFileUploadLicensesVisualizations === 1"
      ref="modalContent"
    >
      <transition name="modal-animate" appear>
        <div
          class="mw-600 zt-modal rounded bg-white w-full shadow-lg relative lg:w-auto m-4"
        >
          <div class="flex items-center px-4 pt-8 rounded-t">
            <p class="mx-8 text-zt-primary-200 text-zt-xl font-bold">
              {{ $t('message.uploadImageComponent.fileUploadLicenses.title') }}
            </p>
            <div
              class="ml-auto zt-modal-button-close p-1 flex items-center justify-center cursor-pointer rounded-full hover:text-zt-primary-200"
              data-vs-button="modal-button-close-file-upload"
              @click.stop="
                $emit('close')
                $store.dispatch('setPopupFileUploadLicensesVisualizations', 2)
              "
            >
              <zt-icon class="" name="times" />
            </div>
          </div>
          <div class="flex justify-start items-center p-4">
            <p class="mx-8 text-zt-lg">
              {{
                $t(
                  'message.uploadImageComponent.fileUploadLicenses.description'
                )
              }}
            </p>
          </div>
          <div id="container-btn" class="justify-start items-center px-4 pb-4">
            <button
              v-show="showbtn"
              class="bt-saber-mas mx-8"
              data-vs-button="saber-mas-button"
              @click="Mostrar_Ocultar()"
              type="button"
            >
              {{
                $t('message.uploadImageComponent.fileUploadLicenses.knowMore')
              }}
            </button>
          </div>
          <div
            v-show="!showbtn"
            id="caja"
            class="justify-start items-center px-4 pb-4"
          >
            <div>
              <p class="mx-8 text-zt-lg font-bold">
                {{
                  $t(
                    'message.uploadImageComponent.fileUploadLicenses.benefits.title'
                  )
                }}
              </p>
              <ul class="m-8 mt-4 leading-none px-4 text-zt-lg">
                <li
                  v-for="(benefit, index) in $t(
                    'message.uploadImageComponent.fileUploadLicenses.benefits.list'
                  )"
                  :key="index"
                  class="mb-6"
                >
                  {{ benefit }}
                </li>
              </ul>
              <p class="m-8 mb-2 text-zt-lg font-bold">
                {{
                  $t(
                    'message.uploadImageComponent.fileUploadLicenses.howToActivate.title'
                  )
                }}
              </p>
              <p class="m-8 mt-0 text-zt-lg">
                {{
                  $t(
                    'message.uploadImageComponent.fileUploadLicenses.howToActivate.description'
                  )
                }}
                <a
                  class="text-decoration text-zt-primary-200 font-bold"
                  href="mailto:soporte@sichern.com..."
                >
                  {{
                    $t(
                      'message.uploadImageComponent.fileUploadLicenses.howToActivate.support'
                    )
                  }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import User from '../../apiClient/User'

export default {
  name: 'PopupFileUploadLicenses',
  props: {
    userName: String
  },
  data() {
    return {
      msg: '',
      active: false,
      showbtn: true
    }
  },
  created() {
    this.user = new User()
    this.getMsgNewVersion()
    document.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 27) {
        this.active = false
      }
    })
  },
  methods: {
    getMsgNewVersion() {
      if (this.$store.state.popupFileUploadLicensesVisualizations === 0) {
        this.user
          .getNotificationFileUploadLicenses()
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch(
                'setPopupFileUploadLicensesVisualizations',
                1
              )
            }
          })
          .catch((e) => {
            if (e.response.status === 404) {
              this.$store.dispatch('setPopupMantenimientoVisualizations', 0)
            }
          })
      }
    },
    Mostrar_Ocultar() {
      this.showbtn = !this.showbtn
    }
  }
}
</script>

<style lang="scss" scoped>
.bt-saber-mas {
  background-color: #dbebfb;
  border-radius: 4px;
  color: #6484f4;
  font-size: 17px;
  padding: 10px 18px;
  font-weight: 500;
}

.mw-600 {
  max-width: 600px;
}

li::before {
  display: inline-block;
  content: '\2022';
  padding-right: 8px;
  color: #5867dd;
  font-size: 30px;
  vertical-align: -5px;
  width: 0.5em;
  margin-left: -0.5em;
}

.text-decoration {
  text-decoration: underline;
}

.new-version-content {
  ::v-deep .zt-modal {
    overflow: hidden;
    overflow-y: auto;
  }

  ::v-deep .zt-modal-button-close i {
    color: #fff;
  }

  ::v-deep .zt-modal {
    max-width: 600px;
  }

  .bullet-notify {
    background: #898dff;
    height: 10px;
    width: 10px;
    max-width: 10px;
    min-width: 10px;
    margin-top: 3px;
    margin-right: 10px;
  }

  .welcome-title {
    margin-bottom: 0;
    margin-top: 0;
  }

  @media (min-width: 768px) {
    .img-notify {
      max-width: -moz-available;
      max-width: -webkit-fill-available;
      max-width: fill-available;
    }

    .welcome-title {
      margin-bottom: 2rem;
      margin-top: 2rem;
    }
  }
}
</style>
